import React from "react";
import '../CSS/PopUp.css'
import { FaTimes } from 'react-icons/fa';
/**
 * 1: Wet Lab
 * 2: Dry Lab
 * 3: Sci Comm
 * 4: Advisors
 * 5: Investigators
 */
const DeptMap = ['Wet Lab', 'Dry Lab', 'Science Communication', 'Advisor', 'Investigators']


class PopUp extends React.Component {
    constructor(props) {
        super(props);
        const { member } = this.props;
        this.setState = {
            memberObj: member,
        };
    }

    handleClick = () => {
        this.props.toggle();
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps !== this.props) {
            const { member } = this.props;
            this.setState({
                memberObj: member,
            })
        }
    }

    render() {
        const normalPic = <img src={this.props.member.icon} style={{ width: '250px', borderRadius: '15px' }} alt='' className="model_img" />
        const minePic = <a href="https://www.linkedin.com/in/yuenyipun/" target="_blank" rel="noreferrer"><img src={this.props.member.icon} style={{ width: '250px', borderRadius: '15px' }} className="model_mine_img" alt='' /></a>

        return (
            <div className="modal">
                <div className="modal_content">

                    <div style={{ display: 'flex', justifyContent: 'space-evenly', flexWrap: 'wrap', textAlign: 'center', paddingLeft: '30px', paddingRight: '30px' }}>
                        {this.props.member.name === 'Clara Pun' ? minePic : normalPic}
                        <div className="model_text">
                            <ul style={{ listStyle: 'none', paddingTop: '20px', textAlign: 'left', paddingBottom: '20px', paddingLeft: '30px', paddingRight: '20px' }}>
                                <li ><h2 style={{ fontFamily: 'var(--fredericka) !important'}}>{this.props.member.name}</h2></li><br />
                                <li>Role: {this.props.member.role}</li><br />
                                {this.props.member.major === '' || this.props.member.dept === 5 || this.props.member.dept === 4 ? null : <><li>Major: {this.props.member.major}</li><br /></>}
                                {this.props.member.major === '' || this.props.member.dept === 5 || this.props.member.dept === 4 ? null : <li>Department: {DeptMap[this.props.member.dept - 1]}</li>}
                            </ul>
                        </div>

                    </div>
                    <div className="close">
                        <span onClick={this.handleClick}><FaTimes style={{ color: 'var(--theme-color)' }} /> </span>

                    </div>
                </div>
            </div>
        );
    }
}

export default PopUp;
